import collectionPoster from '@/assets/images/spring-bloom-collection.png';

export const order = 2;

export default {
  collection_name: 'Spring Bloom Collection',
  collection_desc:
    'Discover the Spring Bloom Collection. This collection has color tones ranging from light to dark.​5/8″ Thickness, 7-1/2″ Width, 4mm Top Layer, UV Urethane Finish.',
  collection_poster:
    collectionPoster,
  products: [
    {
      product_name: 'Amber Bloom',
      sku: 'SBJ05',
      product_desc:
        'Warm amber tones meet the natural character of oak in a refined, understated finish. Amber Bloom brings quiet warmth and timeless elegance to contemporary interiors.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Amber%20Bloom/Amber%20Bloom%20Interior01.jpg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Amber%20Bloom/Amber%20Bloom1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Amber%20Bloom/Amber%20Bloom2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Amber%20Bloom/Amber%20Bloom3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Amber%20Bloom/Amber%20Bloom4.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Amber%20Bloom/Amber%20Bloom%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Amber%20Bloom/Amber%20Bloom1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Amber Bloom'],
        ['Grade', 'Prime'],
        ['Wear Layer', '4mm'],
        ['Width', '7.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Aurora Glow',
      sku: 'SBJ06',
      product_desc:
        'Bathed in a soft golden radiance, Aurora Glow reveals the natural depth and elegance of oak. Its luminous warmth and refined grain create a serene foundation with an unmistakably elevated presence.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Aurora%20Glow/Aurora%20Glow%20Interior01.jpg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Aurora%20Glow/Aurora%20Glow1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Aurora%20Glow/Aurora%20Glow2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Aurora%20Glow/Aurora%20Glow3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Aurora%20Glow/Aurora%20Glow4.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Aurora%20Glow/Aurora%20Glow%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Aurora%20Glow/Aurora%20Glow1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Aurora Glow'],
        ['Grade', 'Prime'],
        ['Wear Layer', '4mm'],
        ['Width', '7.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Buttered Wheat 7.5',
      sku: '6108',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Buttered%20Wheat%207.5/Buttered%20Wheat%207.5%20Interior01.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Buttered%20Wheat%207.5/Buttered%20Wheat%207.5_01.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Buttered%20Wheat%207.5/Buttered%20Wheat%207.5_02.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Buttered%20Wheat%207.5/Buttered%20Wheat%207.5_03.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Buttered%20Wheat%207.5/Buttered%20Wheat%207.5_04.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Buttered%20Wheat%207.5/Buttered%20Wheat%20Video%207.5_01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Buttered%20Wheat%207.5/Buttered%20Wheat%207.5_01.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Buttered Wheat 7.5'],
        ['Grade', 'Character'],
        ['Wear Layer', '4mm'],
        ['Width', '7.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Buttered Wheat',
      sku: 'SBJ08',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Buttered%20Wheat/Buttered%20Wheat%20Interior01.jpg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Buttered%20Wheat/Buttered%20Wheat1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Buttered%20Wheat/Buttered%20Wheat2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Buttered%20Wheat/Buttered%20Wheat3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Buttered%20Wheat/Buttered%20Wheat4.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Buttered%20Wheat/Buttered%20Wheat%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Buttered%20Wheat/Buttered%20Wheat1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Buttered Wheat'],
        ['Grade', 'Prime'],
        ['Wear Layer', '4mm'],
        ['Width', '7.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Toasted Almond',
      sku: 'SBJ10',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Toasted%20Almond/Toasted%20Almond%20Interior01.jpg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Toasted%20Almond/Toasted%20Almond1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Toasted%20Almond/Toasted%20Almond2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Toasted%20Almond/Toasted%20Almond3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Toasted%20Almond/Toasted%20Almond4.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Toasted%20Almond/Toasted%20Almond%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Toasted%20Almond/Toasted%20Almond1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Toasted Almond'],
        ['Grade', 'Character'],
        ['Wear Layer', '4mm'],
        ['Width', '7.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Harvest Gold',
      sku: 'SBJ11',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Harvest%20Gold/Harvest%20Gold%20Interior01.jpg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Harvest%20Gold/Harvest%20Gold1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Harvest%20Gold/Harvest%20Gold2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Harvest%20Gold/Harvest%20Gold3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Harvest%20Gold/Harvest%20Gold4.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Harvest%20Gold/Harvest%20Gold%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Harvest%20Gold/Harvest%20Gold1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Harvest Gold'],
        ['Grade', 'Character'],
        ['Wear Layer', '4mm'],
        ['Width', '7.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Golden Horizon 7.5',
      sku: 'SBJ12',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Golden%20Horizon%207.5/Golden%20Horizon%207.5%20Interior01.jpg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Golden%20Horizon%207.5/Golden%20Horizon%207.5_1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Golden%20Horizon%207.5/Golden%20Horizon%207.5_2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Golden%20Horizon%207.5/Golden%20Horizon%207.5_3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Golden%20Horizon%207.5/Golden%20Horizon%207.5_4.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Golden%20Horizon%207.5/Golden%20Horizon%207.5%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Golden%20Horizon%207.5/Golden%20Horizon%207.5_1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Golden Horizon 7.5'],
        ['Grade', 'Character'],
        ['Wear Layer', '4mm'],
        ['Width', '7.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Golden Horizon Prime',
      sku: '5912',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Golden%20Horizon%20Prime/Golden%20Horizon%20Prime%20Interior01.jpg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Golden%20Horizon%20Prime/Golden%20Horizon%20Prime1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Golden%20Horizon%20Prime/Golden%20Horizon%20Prime2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Golden%20Horizon%20Prime/Golden%20Horizon%20Prime3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Golden%20Horizon%20Prime/Golden%20Horizon%20Prime4.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Golden%20Horizon%20Prime/Golden%20Horizon%20Prime%20%20Video1.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Golden%20Horizon%20Prime/Golden%20Horizon%20Prime1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Golden Horizon Prime'],
        ['Grade', 'Prime'],
        ['Wear Layer', '4mm'],
        ['Width', '7.5"'],
        ['Thickness', '9/16"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Honey Drift',
      sku: 'SBJ13',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Honey%20Drift/Honey%20Drift%20Interior01.jpg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Honey%20Drift/Honey%20Drift1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Honey%20Drift/Honey%20Drift2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Honey%20Drift/Honey%20Drift3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Honey%20Drift/Honey%20Drift4.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Honey%20Drift/Honey%20Drift%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Honey%20Drift/Honey%20Drift1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Honey Drift'],
        ['Grade', 'Character'],
        ['Wear Layer', '4mm'],
        ['Width', '7.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Harvest Moon 7.5',
      sku: 'SBJ14',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Harvest%20Moon%207.5/Harvest%20Moon%207.5%20Interior01.jpg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Harvest%20Moon%207.5/Harvest%20Moon%207.5_1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Harvest%20Moon%207.5/Harvest%20Moon%207.5_2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Harvest%20Moon%207.5/Harvest%20Moon%207.5_3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Harvest%20Moon%207.5/Harvest%20Moon%207.5_4.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Harvest%20Moon%207.5/Harvest%20Moon%207.5%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Harvest%20Moon%207.5/Harvest%20Moon%207.5_1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Harvest Moon 7.5'],
        ['Grade', 'Character'],
        ['Wear Layer', '4mm'],
        ['Width', '7.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Harvest Moon Select',
      sku: 'SBJ16',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Harvest%20Moon%20Select/Harvest%20Moon%20Select%20Interior01.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Harvest%20Moon%20Select/Harvest%20Moon%20Select01.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Harvest%20Moon%20Select/Harvest%20Moon%20Select02.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Harvest%20Moon%20Select/Harvest%20Moon%20Select03.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Harvest%20Moon%20Select/Harvest%20Moon%20Select04.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Harvest%20Moon%20Select/Harvest%20Moon%20Select%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Harvest%20Moon%20Select/Harvest%20Moon%20Select01.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Harvest Moon Select'],
        ['Grade', 'Prime'],
        ['Wear Layer', '4mm'],
        ['Width', '7.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Honey Amber Prime',
      sku: 'SBJ28',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Honey%20Amber%20Prime/Honey%20Amber%20Prime%20Interior%2001.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Honey%20Amber%20Prime/Honey%20Amber%20Prime1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Honey%20Amber%20Prime/Honey%20Amber%20Prime2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Honey%20Amber%20Prime/Honey%20Amber%20Prime3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Honey%20Amber%20Prime/Honey%20Amber%20Prime4.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Honey%20Amber%20Prime/Honey%20Amber%20Prime5.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Honey%20Amber%20Prime/Honey%20Amber%20Prime%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Honey%20Amber%20Prime/Honey%20Amber%20Prime1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Honey Amber Prime'],
        ['Grade', 'Prime'],
        ['Wear Layer', '4mm'],
        ['Width', '7.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Sunset Glow 7.5',
      sku: '62203',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Sunset%20Glow%207.5/Sunset%20Glow%207.5%20Interior01.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Sunset%20Glow%207.5/Sunset%20Glow%207.5_01.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Sunset%20Glow%207.5/Sunset%20Glow%207.5_02.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Sunset%20Glow%207.5/Sunset%20Glow%207.5_03.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Sunset%20Glow%207.5/Sunset%20Glow%207.5%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Sunset%20Glow%207.5/Sunset%20Glow%207.5_01.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Sunset Glow 7.5'],
        ['Grade', 'Light Character'],
        ['Wear Layer', '4mm'],
        ['Width', '7.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Shibumi',
      sku: 'SBJ29',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Shibumi/ShibumiInterior01.jpg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Shibumi/Shibumi01.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Shibumi/Shibumi02.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Shibumi/Shibumi03.JPG',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Shibumi/Shibumi04.JPG',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Shibumi/Shibumi05.JPG',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Shibumi/Shibumi%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Spring%20Bloom%20Collection/Shibumi/Shibumi01.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Shibumi'],
        ['Grade', 'Character'],
        ['Wear Layer', '4mm'],
        ['Width', '7.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
  ],
};
